<div class="loginContainer" [ngClass]="{'is-mobile-view': isMobileView}">
   <div class="graphic" [ngClass]="{'is-mobile-view': isMobileView}">
      <span class="login_logo_container"><img class="logo" src="{{imageRootFolder}}Claro_logo_whit_on_blue.svg"></span>
      <span class="login_topic_container" *ngIf="isMobileView">
         <span class="login_topic">{{'login.joinHR' | translate}}</span>
         <span class="login_topic_bold">{{'login.revolution' | translate}}</span>
      </span>
      <img class="login_image" *ngIf="!isMobileView" src="{{imageRootFolder}}login.png">
   </div>
   <div class="login_form" [ngClass]="{'is-mobile-view': isMobileView}">
      <div class="formBottomPart" [ngClass]="{'is-mobile-view': isMobileView}">
         <div class="text">
            <span class="subTitle" [ngClass]="{'is-mobile-view': isMobileView}">{{'login.welcomeMessage' | translate}}</span>
            <span class="title" [ngClass]="{'is-mobile-view': isMobileView}">{{'login.loginDirective' | translate}}</span>
         </div>
         <!-- <form #myform = "ngForm" (ngSubmit) = "onSubmit(myform)" >
         <div class = 'form-group'><input class = 'form-control' type = "text" name = "userMail" placeholder = "abc@hotmail.com" ngModel></div>
         <div class = 'form-group'><input class = 'form-control' type = "password" name = "password" placeholder = "Password" ngModel></div>
         <input class= 'btn btn-outline-info' type = "submit" value = "Login"></form> -->
         <div class="userFormFields" *ngIf="!isForgotPasswordView" [ngClass]="{'is-mobile-view': isMobileView}" >
            <!-- <mat-label class="passwordLabel">{{'login.email' | translate}}</mat-label> -->
            <mat-form-field class="longField" appearance="fill">
               <mat-label>{{'login.email' | translate}}</mat-label>
               <input matInput [(ngModel)]="userMail">
            </mat-form-field>
            <!-- <mat-label class="passwordLabel">{{'personal.enterNewPassword' | translate}}</mat-label> -->
            <mat-form-field  (keyup.enter)="submit()" class="longField" appearance="fill">
               <mat-label>{{'login.password' | translate}}</mat-label>
               <input matInput [(ngModel)]="password" [type]="hidePassword ? 'password' : 'text'">
               <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword">
               <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
               </button>
            </mat-form-field>
            <span class="errorMessage" *ngIf="lastLoginFailedOnCreds">{{'login.wrongCredentials' | translate}}</span>
            <span class="errorMessage" *ngIf="lastLoginFailedGeneral">{{'login.generalIssue' | translate}}</span>
            <span class="directiveMessage" *ngIf="passwordResetRequestWasSent">{{'login.resetPasswordWasSent' | translate}}</span>          
            <span class="loginButtons" [ngClass]="{'is-mobile-view': isMobileView}">
               <button mat-raised-button class="submitButton" (click)="submit()">{{'login.submitButton'|translate}}</button>
               <div class="login_forgotAndRegisterBtns_container">
                  <button mat-button class="forgotPasswordButton" [ngClass]="{'is-mobile-view': isMobileView}" (click)="forgotPassword()">{{'login.forgotPassword' | translate}}</button>
                  <div class="login_register_container" [ngClass]="{'is-mobile-view': isMobileView}">
                     <span class="login_registerText">{{'login.notAUser' | translate}}</span>
                     <a class="login_registerLink" (click)="registerNewUser()">{{'login.registerHere' | translate}}</a>
                   </div>
               </div>
            </span>
         </div>
         <div class="userFormFields" *ngIf="isForgotPasswordView">
            <!-- <mat-label class="passwordLabel">{{'login.email' | translate}}</mat-label> -->
            <span class="directiveMessage">{{'login.resetPasswordDirective' | translate}}</span>
            <mat-form-field class="longField" appearance="fill">
               <mat-label>{{'login.email' | translate}}</mat-label>
               <input matInput [(ngModel)]="resetPasswordUserMail" required>
            </mat-form-field>
            <button mat-raised-button class="submitButton" (click)="forgotPasswordSubmit()">{{'login.forgotPasswordSubmitButton'|translate}}</button>
         </div>         
   </div>
   </div>
</div>
